import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'SelectFolderInsideGroup'
}

import { useGroupStore } from '@/store/group'
import Finder from '@/components/finder'
import type { FinderProps, FinderResponse } from '@/components/finder/types'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["close", "cancel", "confirm"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'cancel'): void
  (e: 'confirm', context): void
}), expose: any, slots: any, attrs: any }) {



const groupStore = useGroupStore()

const finderProps: FinderProps = {
  action: 'selectPath',
  path: {
    name: 'TeamFiles',
    groupid: groupStore.groupId,
    params: {
      tid: groupStore.groupId,
      fid: 0
    }
  },
  tabs: [],
  featrues: {
    excludes: ['isLatestUseFolder', 'isShowSearch', '~']
  }
}

const closeCurrentDialog = () => {
  emit('close')
}
const confirm = (response: FinderResponse) => {
  closeCurrentDialog()
  emit('confirm', {
    finder: {
      ftype: 'folder',
      cid: response.group?.corpid || 0,
      tid: response.path.params.tid,
      fid: response.path.params.fid || 0,
      name: response.path.text
    }
  })
}

const cancel = () => {
  closeCurrentDialog()
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Finder), _mergeProps({ class: "finder-container" }, finderProps, {
    onConfirm: confirm,
    onCancel: cancel
  }), null, 16))
}
}

})